import { apiFetch, apiFetchJson } from "@/utils/apiFetch";

const BASE_API_URL = import.meta.env.VITE_API_URL;

export const pushService = {
  getVapidPublicKey: async (): Promise<{ public_key: string }> => {
    return apiFetchJson<{ public_key: string }>(
      `${BASE_API_URL}/notifications/push/vapid-public-key/`,
    );
  },
  saveSubscription: async (
    subscription: PushSubscriptionJSON,
  ): Promise<any> => {
    return apiFetchJson<any>(
      `${BASE_API_URL}/notifications/push/subscriptions/`,
      { method: "POST", body: JSON.stringify(subscription) },
    );
  },
  deleteSubscription: async (endpoint: string): Promise<Response> => {
    return apiFetch(`${BASE_API_URL}/notifications/push/subscriptions/`, {
      method: "DELETE",
      body: JSON.stringify({ endpoint }),
    });
  },
};
